var _dec, _dec2, _dec3, _class, _descriptor, _descriptor2, _descriptor3, _BloodPressureSessionStartedJournalEvent;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import { belongsTo, hasMany } from "@ember-data/model";
import { assert } from "@ember/debug";
import BloodPressureMeasuredJournalEvent from "core/models/blood-pressure-measured-journal-event";
import BloodPressureSessionRequestedJournalEvent from "core/models/blood-pressure-session-requested-journal-event";
import JournalEvent from "core/models/journal-event";
import Patient from "core/models/patient";
import { sortBy } from "core/utils/sort";
import tWithDefault from "core/utils/t-with-default";
import { dayDiffBetweenDates } from "core/utils/time";
import dayjs from "dayjs";
import { validateDate, validatePresence } from "ember-changeset-validations/validators";
import IntlService from "ember-intl/services/intl";

//---- Automatically generated, don't update this part ----
let BloodPressureSessionStartedJournalEvent = (_dec = hasMany("blood-pressure-measured-journal-event", {
  async: false,
  inverse: "bloodPressureSessionStartedJournalEvent"
}), _dec2 = belongsTo("blood-pressure-session-requested-journal-event", {
  async: false,
  inverse: "bloodPressureSessionStartedJournalEvent"
}), _dec3 = belongsTo("patient", {
  async: false,
  inverse: "bloodPressureSessionStartedJournalEvents"
}), _class = (_BloodPressureSessionStartedJournalEvent = class BloodPressureSessionStartedJournalEvent extends JournalEvent {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "bloodPressureMeasuredJournalEvents", _descriptor, this);
    //---- End of generated code ----
    _initializerDefineProperty(this, "bloodPressureSessionRequestedJournalEvent", _descriptor2, this);
    _initializerDefineProperty(this, "patient", _descriptor3, this);
  }
  static validations(intl) {
    return {
      occurredAt: [validatePresence({
        presence: true,
        description: tWithDefault(intl, "validations.blood-pressure-session-started-journal-event.occurred-at", "La date")
      }), validateDate({
        message: "Cette donnée ne peut être déclarée avant 1900. Veuillez modifier la date",
        onOrAfter: new Date("01/01/1900")
      }), validateDate({
        message: "Cette donnée ne peut être déclarée plus de 50 ans en avance. Veuillez modifier la date",
        onOrBefore: dayjs().add(50, "years").toDate()
      })]
    };
  }
  get sortedBloodPressureMeasuredJournalEvents() {
    return this.bloodPressureMeasuredJournalEvents.toSorted(sortBy("occurredAt"));
  }
  get isAlertingJournalEvent() {
    return this.bloodPressureMeasuredJournalEvents.slice().map(bp => bp.alertTriggeredJournalEvents).flat().length > 0;
  }
  get meanSystolicPressure() {
    return _computeMeanMeasurements(this.bloodPressureMeasuredJournalEvents, "systolicPressure");
  }
  get meanDiastolicPressure() {
    return _computeMeanMeasurements(this.bloodPressureMeasuredJournalEvents, "diastolicPressure");
  }
  get meanHeartRate() {
    return _computeMeanMeasurements(this.bloodPressureMeasuredJournalEvents, "heartRate");
  }

  /**
   * All the JE of today
   */
  get todayMeasurements() {
    return this.bloodPressureMeasuredJournalEvents.filter(je => je.sessionDay == this.currentSessionDay);
  }
  get hasCompletedAllMeasurementsOfTheDay() {
    return this.todayMeasurements.length >= BloodPressureSessionStartedJournalEvent.MEASURE_BY_DAY;
  }

  /**
   *  An integer between zero and three representing the current day of the session
   */
  get currentSessionDay() {
    return dayDiffBetweenDates(this.occurredAt, new Date());
  }
  hasAlertForCode(code) {
    return Boolean(this.bloodPressureMeasuredJournalEvents.find(bp => bp.hasAlertForCode(code)));
  }

  /**
   * Convert a Date into an integer corresponding to the sessionDay of this session
   * returns The session day corresponding to this session
   */
  getSessionDay(date) {
    return dayDiffBetweenDates(this.occurredAt, date);
  }

  /**
   * Return the date corresponding to the given day index
   */
  getDayDate(day) {
    const date = new Date(this.occurredAt);
    date.setDate(date.getDate() + day);
    return date;
  }

  /**
   * Return all the measurement for a specific session  day
   * sessionDay: An integer between zero and three representing the current day of the session
   */
  getMeasurementsOfSessionDay(sessionDay) {
    return this.bloodPressureMeasuredJournalEvents.filter(je => je.sessionDay == sessionDay);
  }
  getMorningMeasurementsOfSessionDay(sessionDay) {
    return this.getMeasurementsOfSessionDay(sessionDay).filter(m => m.isMorning);
  }
  getEveningMeasurementsOfSessionDay(sessionDay) {
    return this.getMeasurementsOfSessionDay(sessionDay).filter(m => !m.isMorning);
  }
  computeDateForMeasurement(sessionDay, isMorning) {
    const measureIndex = (isMorning ? this.getMorningMeasurementsOfSessionDay : this.getEveningMeasurementsOfSessionDay).call(this, sessionDay).length;
    return BloodPressureMeasuredJournalEvent.createMeasurementDate(this.occurredAt, sessionDay, isMorning, measureIndex);
  }
  get measurementsDay1() {
    return this.getMeasurementsOfSessionDay(0);
  }
  get measurementsDay2() {
    return this.getMeasurementsOfSessionDay(1);
  }
  get measurementsDay3() {
    return this.getMeasurementsOfSessionDay(2);
  }
  get isOpened() {
    return this._isOpened(new Date());
  }

  /**
   * The begin of the day when the session starts
   */
  get beginDate() {
    return dayjs(this.occurredAt).startOf("day").toDate();
  }

  /**
   * The exact date when the session finish
   */
  get endDate() {
    return dayjs(this.beginDate).add(this.sessionDuration - 1, "day").endOf("day").toDate();
  }

  /**
   * Return true if the session passed as parameter will overlap this session
   * A session lasts 3 days so a session that starts less than two days before an existing session will overlap it.
   * @param date
   */
  isSessionStartDateMayOverlap(date) {
    return dayjs(date).isAfter(dayjs(this.beginDate).subtract(3, "day")) && dayjs(date).isBefore(this.endDate);
  }

  /**
   * Splitted for testing
   */
  _isOpened(nowDate) {
    const mSession = new Date(this.occurredAt);
    const mNow = new Date(nowDate);
    const dayDiff = dayDiffBetweenDates(mNow, mSession);
    assert("The session must occur before now", dayDiff >= 0);
    return dayDiff < BloodPressureSessionStartedJournalEvent.SESSION_DURATION;
  }

  /**
   * return True if it's the last day of the session. Meaning day 2 as we start at 0
   */
  get isLastDay() {
    return this.currentSessionDay >= 2;
  }
  get sessionDuration() {
    return BloodPressureSessionStartedJournalEvent.SESSION_DURATION;
  }

  /**
   * The duration of a session in days
   */
}, _defineProperty(_BloodPressureSessionStartedJournalEvent, "type", "blood-pressure-session-started-journal-event"), _defineProperty(_BloodPressureSessionStartedJournalEvent, "SESSION_DURATION", 3), _defineProperty(_BloodPressureSessionStartedJournalEvent, "MEASURE_BY_DAY", 6), _BloodPressureSessionStartedJournalEvent), _descriptor = _applyDecoratedDescriptor(_class.prototype, "bloodPressureMeasuredJournalEvents", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "bloodPressureSessionRequestedJournalEvent", [_dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "patient", [_dec3], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _class);
export { BloodPressureSessionStartedJournalEvent as default };
/****** PRIVATE ******/
function _computeMeanMeasurements(measurementJes, propertyName) {
  const measures = measurementJes.map(je => je[propertyName]).filter(measure => measure != null);
  if (measures.length == 0) {
    return undefined;
  }
  const mean = measures.reduce((acc, measure) => acc + measure, 0) / measures.length;
  if (Number.isNaN(mean)) {
    return 0;
  }
  return mean;
}

// DO NOT DELETE: this is how TypeScript knows how to look up your models.